<template>
  <div class="box-info">
    <div class="info-nav-left">
      <div class="left-top">
        <i class="iconfont iconfenlei1"></i>
      </div>
      <div class="nav-item" :class="{active:type===0}" @click="toInfo('/home/hxrAdmin/hxrList')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconrenyuanjieshao" style="top: 0;"></i>
          </div>
        </div>
        候选人列表
      </div>
      <div class="nav-item" :class="{active:type===1}" @click="toInfo('/home/hxrAdmin/hxrForm')" v-if="user.admin_type===2 || user.admin_type===3|| user.admin_type===4">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconbiaodan2"></i>
          </div>
        </div>
        我的表单
      </div>
      <div class="nav-item" :class="{active:type===2}" @click="toInfo('/home/hxrAdmin/hxrPaiming')" >
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconnenghaopaiming"></i>
          </div>
        </div>
        简历推荐排名
      </div>
      <div class="nav-item" :class="{active:type===3}" @click="toInfo('/home/hxrAdmin/hxrPaiming2')" >
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconnenghaopaiming"></i>
          </div>
        </div>
        候选人推荐排名
      </div>
      <div class="nav-item" :class="{active:type===4}" @click="isshow = !isshow" style="position: relative">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconshenhe"></i>
          </div>
        </div>
        审核
        <i class="iconfont icondian"
           style="position: absolute;color: #e4393c;top: 0px;right: 0px; width: 40px;font-size: 40px;height: 40px;"
           v-if="jianli!==0 || jiben!==0 || qiuzhi!==0 "></i>
      </div>
      <div class="nat-item-two" v-show="type===4 || isshow">
        <div :class="{active:twoNav===0}" @click="toInfo('/home/hxrAdmin/fabuShen')">简历发布审核
        <i class="iconfont icondian"
           style="position: absolute;color: #e4393c;top: 0px;right: 0px; width: 40px;font-size: 40px;height: 40px;"
           v-if="jianli!==0"></i>
        </div>
        <div :class="{active:twoNav===1}" @click="toInfo('/home/hxrAdmin/xinxiShen')">基础信息审核
        <i class="iconfont icondian"
           style="position: absolute;color: #e4393c;top: 0px;right: 0px; width: 40px;font-size: 40px;height: 40px;"
           v-if="jiben!==0"></i>
        </div>
        <div :class="{active:twoNav===2}" @click="toInfo('/home/hxrAdmin/qiuzhi')">求职信发布审核
        <i class="iconfont icondian"
           style="position: absolute;color: #e4393c;top: 0px;right: 0px; width: 40px;font-size: 40px;height: 40px;"
           v-if="qiuzhi!==0"></i>
        </div>
      </div>
      <div class="nav-item" :class="{active:type===5}" @click="toInfo('/home/hxrAdmin/hxrInvitation')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconjia1"></i>
          </div>
        </div>
        邀请注册
      </div>
      <div class="nav-item" :class="{active:type===6}" @click="toInfo('/home/hxrAdmin/addList')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont icondian"></i>
          </div>
        </div>
        邀请统计
      </div>
    </div>
    <div class="right">
      <router-view @setType="setType"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: "xhrAdmin",
    data() {
      return {
        type: '',
        twoNav: '',
        isshow: false,
        jiben:0,
        jianli:0,
        qiuzhi:0
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$store.state.topNav = 1
      this.getZnx()
    },
    methods: {
      toInfo(path) {
        this.$router.push(path)
      },
      setType(type, twoNav) {
        this.type = type
        if (this.type !== 4) {
          this.isshow = false
          this.twoNav = ''
        } else {
          this.twoNav = twoNav
        }
      },
      getZnx() {
        this.$api.apiContent.getZnx({
          adminId: this.user.id
        }).then(res => {
          this.jiben = res.data.candidateInfoCheck
          this.jianli =  res.data.resume
          this.qiuzhi = res.data.coverLetterr
          console.log(this.znxNum)
        }).catch(e => {
          console.log(e)
        })
      }
    }
  }
</script>

<style scoped lang="scss">

</style>